import { CapacityPlanTab } from './CapacityPlanTab';

export interface CapacityPlanTabsProps {
  activeTab: CapacityPlanTab;
  onTabClick: (tab: CapacityPlanTab) => void;
  /** Count pill on the Deliveries tab; left out while the rows are unknown. */
  deliveriesCount?: number;
}

/** Id of one tab button, so its panel can name the tab that opened it. */
export const capacityPlanTabId = (tab: CapacityPlanTab) =>
  `capacityPlanTab-${tab}`;

/** Id of the single panel the three tabs share. */
export const capacityPlanTabPanelId = 'capacityPlanTabPanel';

const labels: { key: CapacityPlanTab; label: string }[] = [
  { key: 'deliveries', label: 'Deliveries' },
  { key: 'result', label: 'Result' },
  { key: 'settings', label: 'Settings' },
];

const tabClasses =
  '-mb-px border-b-2 border-transparent px-3 py-2 text-light-black dark:text-sublte-white';

const activeTabClasses =
  'border-red font-semibold text-design-black dark:text-white';

const CapacityPlanTabs = ({
  activeTab,
  onTabClick,
  deliveriesCount,
}: CapacityPlanTabsProps) => (
  <div
    role="tablist"
    aria-label="Run sections"
    className="flex gap-2 border-b border-design-secondary-black"
  >
    {labels.map(({ key, label }) => (
      <button
        key={key}
        id={capacityPlanTabId(key)}
        type="button"
        role="tab"
        aria-selected={activeTab === key}
        aria-controls={capacityPlanTabPanelId}
        className={`${tabClasses} ${activeTab === key ? activeTabClasses : ''}`}
        onClick={() => onTabClick(key)}
      >
        {label}
        {key === 'deliveries' && deliveriesCount !== undefined && (
          <span className="ml-1.5 rounded-sm bg-muted-white px-1.5 text-xs dark:bg-design-black-accent">
            {deliveriesCount}
          </span>
        )}
      </button>
    ))}
  </div>
);

CapacityPlanTabs.defaultProps = {
  deliveriesCount: undefined,
};

export default CapacityPlanTabs;
